import { render, staticRenderFns } from "./PlateKlineModal.vue?vue&type=template&id=44546a89&scoped=true"
import script from "./PlateKlineModal.vue?vue&type=script&lang=js"
export * from "./PlateKlineModal.vue?vue&type=script&lang=js"
import style0 from "./PlateKlineModal.vue?vue&type=style&index=0&id=44546a89&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44546a89",
  null
  
)

export default component.exports